import React from 'react'
import { Card, CardContent, Typography } from '@material-ui/core'

import { useStyles } from './styles'

const SummaryCard = ({ product, measure, color }) => {
  const classes = useStyles()

  return (
    <Card
      className={classes.root}
      variant="outlined"
      id={`summaryCard${product}`}
    >
      <CardContent>
        <center>
          <Typography
            className={classes.title}
            color="textSecondary"
            id={`summaryCardTitle${product}`}
            gutterBottom
          >
            {measure}
          </Typography>
          <Typography variant="h5" component="h2">
            <b style={{ color }} id={`summaryCardValue${product}`}>
              {product}
            </b>
          </Typography>
        </center>
      </CardContent>
    </Card>
  )
}

export default SummaryCard
